// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__b5sKc","vLegacy":"SelectSecondary_vLegacy__2diSO","error":"SelectSecondary_error__RSKy9","disabled":"SelectSecondary_disabled__2u4k1"};